import { useQuery } from "@apollo/react-hooks";

import regionLookup from "../graph-ql/regionLookup.graphql";

const useQueryRegionLookup = (
  term: string,
  propositionId: string,
  productCategoryId: string,
) =>
  useQuery(regionLookup, {
    variables: { term, propositionId, productCategoryId },
  });

export default useQueryRegionLookup;
